<ion-segment
  [value]="activeSegment()"
  (ionChange)="onSegmentChange($event)"
>
  <ion-segment-button
    value="upcoming"
    layout="icon-start"
  >
    <ion-icon
      aria-hidden="true"
      src="../assets/material-symbols/qr_code_24dp.svg"
    ></ion-icon>
    <ion-label>Vigentes</ion-label>
  </ion-segment-button>
  <ion-segment-button
    value="past"
    layout="icon-start"
  >
    <ion-icon
      aria-hidden="true"
      src="../assets/material-symbols/okc_folder_qr_code_24dp.svg"
    ></ion-icon>
    <ion-label>Archivados</ion-label>
  </ion-segment-button>
</ion-segment>

@if (activeSegment() === 'upcoming') {
  @if (canViewAsCarrier()) {
    <ion-item-divider sticky>
      <ion-icon
        slot="start"
        aria-hidden="true"
        src="../assets/material-symbols/local_shipping_24dp.svg"
      ></ion-icon>
      <div>
        <p class="subtitle">Como transportista</p>
      </div>
    </ion-item-divider>
    <lib-deca-list
      category="UPCOMING_DOCUMENTS_AS_CARRIER"
      [detailRoute]="detailRoute()"
    ></lib-deca-list>
  }
  @if (canViewAsShipper()) {
    <ion-item-divider sticky>
      <ion-icon
        slot="start"
        aria-hidden="true"
        src="../assets/material-symbols/box_24dp.svg"
      ></ion-icon>
      <div>
        <p class="subtitle">Como cargador</p>
      </div>
    </ion-item-divider>
    <lib-deca-list
      category="UPCOMING_DOCUMENTS_AS_SHIPPER"
      [detailRoute]="detailRoute()"
    ></lib-deca-list>
  }
} @else {
  @if (canViewAsCarrier()) {
    <ion-item-divider sticky>
      <ion-icon
        slot="start"
        aria-hidden="true"
        src="../assets/material-symbols/local_shipping_24dp.svg"
      ></ion-icon>
      <div>
        <p class="subtitle">Como transportista</p>
      </div>
    </ion-item-divider>
    <lib-deca-list
      category="PAST_DOCUMENTS_AS_CARRIER"
      [detailRoute]="detailRoute()"
    ></lib-deca-list>
  }
  @if (canViewAsShipper()) {
    <ion-item-divider sticky>
      <ion-icon
        slot="start"
        aria-hidden="true"
        src="../assets/material-symbols/box_24dp.svg"
      ></ion-icon>
      <div>
        <p class="subtitle">Como cargador</p>
      </div>
    </ion-item-divider>
    <lib-deca-list
      category="PAST_DOCUMENTS_AS_SHIPPER"
      [detailRoute]="detailRoute()"
    ></lib-deca-list>
  }
}
